import { AddressComponentTypes, type DetailResult } from './type';
import { type AddressMapping } from './address-mapping';

class AustraliaAddressMapping implements AddressMapping {
    private _placeDetails: DetailResult;

    constructor(placeDetails: DetailResult) {
        this._placeDetails = placeDetails;
    }

    getAddress(): string {
        const streetNumber = this._placeDetails.address_components.find(comp => {
            return comp.types.includes(AddressComponentTypes.STREET_NUMBER)
        })

        const route = this._placeDetails.address_components.find(comp => {
            return comp.types.includes(AddressComponentTypes.ROUTE)
        })


        if (!route) {
            return '';
        }

        if (!streetNumber) {
            return route.longText;
        }

        return streetNumber.longText + ' ' + route.longText;
    }

    getPostcode(): string {
        const postcode = this._placeDetails.address_components.find(comp => {
            return comp.types.includes(AddressComponentTypes.POSTAL_CODE)
        })

        if (!postcode) {
            return '';
        }

        return postcode.longText;
    }

    getSuburb(): string {
        const suburb = this._placeDetails.address_components.find(comp => {
            return comp.types.includes(AddressComponentTypes.LOCALITY)
        })

        if (!suburb) {
            return '';
        }

        return suburb.longText;
    }

    getStateRegionCity(): string {
        const state = this._placeDetails.address_components.find(comp => {
            return comp.types.includes(AddressComponentTypes.ADMINISTRATIVE_AREA_LVL_1)
        })

        if (!state) {
            return '';
        }

        return state.longText;
    }
}

export default {
    map(placeDetails: DetailResult): AddressMapping {
        return new AustraliaAddressMapping(placeDetails);
    }
};
